import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import Table from 'rc-table';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { createStructuredSelector } from 'reselect';
import { BaseComponent } from '../../../components/BaseComponent';
import { WorkflowProductActionsContainer } from './WorkflowProductActionsContainer';
import { HBox } from '../../../components/Box';
import { EditSquare } from '../../../components/Icon';
import { WorkflowProductEditModal } from './WorkflowProductEditModal';

const Container = styled.div`
  width: 100%;
  background: white;
`;

const CustomTable = styled(Table)`
  width: 100%;
  display: flex;
  font-size: 12px;

  .rc-table-container {
    width: 100%;
  }

  .rc-table-content table {
    width: 100%;
  }

  .rc-table-thead {
    background-color: #eff1f7;
    font-weight: 600;
    height: 52px;
    padding: 16px 0;
    margin-left: 8px;
    font-size: 14px;
  }

  td,
  th {
    padding: 8px 12px;
  }

  .icon-block {
    cursor: pointer;
    font-size: 22px;
  }

  .icon-edit-square {
    color: #d9d9d9;
  }
`;

const STATE = {
  isEditQuantity: false,
};

/* eslint-disable react/prefer-stateless-function */
class WorkflowProductsOverviewTableComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  get workflowProducts() {
    return this.props.workflowProducts;
  }

  isPriceDefined(price) {
    if (price || price === 0) return true;
  }

  showEditModal(e, productId) {
    if (this.props.companyId) return;
    e.stopPropagation();
    this.setState({ isEditQuantity: true, editedProductId: productId });
  }

  getData = product => {
    const price = this.isPriceDefined(product.salesPrice) ? product.salesPrice : product?.product?.salesPrice;
    return {
      id: product.id,
      name: product?.product?.name,
      vehiclePurpose: product.vehiclePurpose,
      quantity: product?.quantity,
      price: +price * +product?.quantity,
      oneTimePrice: +price,
      workflow: this.props.workflow,
      actions: product,
    };
  };

  getColumns = () => {
    const workflow = this.props.workflow;
    const edit = this.showEditModal.bind(this);
    const state = this.state;
    const editState = this.setState.bind(this);

    const actionsColumn = {
      key: 'actions',
      dataIndex: 'actions',
      render(value, row, index) {
        return <WorkflowProductActionsContainer workflowProduct={value} workflow={workflow} />;
      },
    };
    const editableQuantitySection = {
      title: this.lblStr('workflows.productDetails.quantity'),
      align: 'left',
      key: 'quantity',
      dataIndex: 'quantity',
      render(value, row) {
        if (state.isEditQuantity && state.editedProductId === row?.id) {
          return (
            <WorkflowProductEditModal
              product={row}
              productId={row?.id}
              workflowId={workflow?.id}
              onClose={() => editState({ isEditQuantity: false })}
            />
          );
        }
        return (
          <HBox left vCenter>
            {value}{' '}
            <div
              className="icon-block"
              onClick={e => {
                edit(e, row?.id);
              }}
            >
              <EditSquare />
            </div>
          </HBox>
        );
      },
    };
    const columns = [
      { title: this.lblStr('workflows.productDetails.name'), dataIndex: 'name', key: 'name', align: 'left' },
      {
        title: this.lblStr('workflows.productDetails.vehiclePurpose'),
        dataIndex: 'vehiclePurpose',
        key: 'vehiclePurpose',
        align: 'left',
      },
      { title: this.lblStr('workflows.productDetails.name'), dataIndex: 'name', key: 'name', align: 'left' },
      editableQuantitySection,
      { title: this.lblStr('workflows.productDetails.price'), dataIndex: 'price', key: 'name', align: 'left' },
    ];

    if (!this.props.workflowDisabled) columns.push(actionsColumn);

    return columns;
  };

  to(url, newWindow) {
    //
    if (newWindow) {
      window.open(url);
    } else {
      this.props.history.push(url);
    }
  }

  render() {
    const columns = this.getColumns();
    const data = this.workflowProducts?.map(p => this.getData(p));

    return (
      <Container>
        <CustomTable
          columns={columns}
          data={data}
          scroll={{ x: window.innerWidth < 975 ? 975 : false }}
          emptyText={'No products added yet'}
          onRow={(record, index) => {
            return {
              onClick: !this.props.companyId
                ? e => {
                    if (e.target.nodeName !== 'TD') return;

                    return this.to(`/workflows/${record.workflow.id}/workflow-product/${record.id}`);
                  }
                : null,

              workflowProduct: this.props.workflowProducts[index],
            };
          }}
        />
      </Container>
    );
  }
}

WorkflowProductsOverviewTableComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onItemClick: PropTypes.func,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const WorkflowProductsOverviewTable = compose(withConnect, withRouter, injectIntl)(WorkflowProductsOverviewTableComp);
